/**
 * Created by Angelika on 30.08.2017.
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from 'prop-types';
import * as strings from '../constants/strings';
import * as AppContentActions from '../actions/appContent';

class UserDataFrame extends Component {

    componentDidMount() {
        const {appContentActions} = this.props;
        appContentActions.showUserDataFrame();
    }

    showItem(label, field) {
        const {userData} = this.props;
        return (userData[field] !== undefined &&
            <div className="user-list-item">
                <label>{label}</label>
                <span>{userData[field]}</span>
            </div>
        )
    }

    sectionInformation(title) {
        return (
            <div className="user-data-container">
                <div className="category-name">{title}</div>
                {this.showItem('ID', 'id')}
                {this.showItem(strings.STR_LOGIN_LOGIN, 'account')}
                {this.showItem(strings.STR_REG_LABEL_FULL_NAME, 'fname')}
            </div>
        );
    }

    sectionTariff(title) {
        return (
            <div className="user-data-container">
                <div className="category-name">{title}</div>
                {this.showItem(strings.STR_USERDATA_TARIFF_PLAN, 'tariff_plan')}
            </div>
        )
    }

    sectionContacts(title) {
        return (
            <div className="user-data-container">
                <div className="category-name">{title}</div>
                {this.showItem('MAC', 'mac')}
                {this.showItem(strings.STR_USERDATA_PHONE, 'phone')}
            </div>
        )
    }

    render() {
        return (
            <section id="user-frame">
                {this.sectionInformation(strings.STR_USERDATA_SECTION_INFO)}
                {this.sectionTariff(strings.STR_USERDATA_SECTION_TARIFF)}
                {this.sectionContacts(strings.STR_USERDATA_SECTION_CONTACTS)}
            </section>
        )
    }
}

UserDataFrame.propTypes = {
    userData: PropTypes.shape({
        account: PropTypes.string,
        fname: PropTypes.string,
        id: PropTypes.number,
        mac: PropTypes.string,
        phone: PropTypes.string,
        tariff_plan: PropTypes.string
    }).isRequired
};

const mapStateToProps = state => {
    return {
        userData: state.users.userData.data
    }
};

const mapDispatchToProps = dispatch => {
    return {
        appContentActions: bindActionCreators(AppContentActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserDataFrame);




// WEBPACK FOOTER //
// ./src/containers/UserDataFrame.js